import React, { useRef, useEffect } from 'react';
import sketchSidebar from './sketchSidebar'; // Import the p5.js sketch

function SidebarCanvas() {
  const canvasRef = useRef();

  useEffect(() => {
    let p5Instance;
    let script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/p5@1.11.8/lib/p5.min.js';
    script.async = true;

    function startSketch() {
      if (!window.p5) return;
      p5Instance = new window.p5(sketchSidebar, canvasRef.current);
    }

    script.onload = startSketch;
    document.body.appendChild(script);

    return () => {
      if (p5Instance) p5Instance.remove();
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      ref={canvasRef}
      style={{
        position: 'absolute',
        zIndex: 0, // Ensure it's behind the sidebar content
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        background: 'transparent', // Ensure no background color obscures the canvas
      }}
      aria-hidden="true"
    />
  );
}

export default SidebarCanvas;